<template>
  <div id="sapp" :class="layoutClass">
    <component v-bind:is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  name: "sapp",
  computed: {
    loggedIn() {
      return this.$store.getters["authentication/loggedIn"];
    },
    layout() {
      return "layout-" + (this.$route.meta.layout || "guest");
    },
    layoutClass() {
      return this.layout == "layout-dashboard" ? "restricted" : "public";
    }
  },
  components: {
    "layout-dashboard": () =>
      import(/* webpackChunkName: "layout-dashboard" */ "./layouts/dashboard"),
    "layout-guest": () =>
      import(/* webpackChunkName: "layout-guest" */ "./layouts/guest")
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<style lang="scss">
// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// @import "~normalize.css/normalize.css";

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import "~nprogress/nprogress.css";

// Imported globally in vue.config.js

// Bulma's core
// @import "~bulma/sass/utilities/_all";
// Custom Variables
// @import "styles/_variables.scss"; // Set your colors

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Fonts
@import "assets/fonts/solicitapp/style.css";
@import "assets/fonts/eina/style.css";

.range-slider-fill {
  background: linear-gradient(90deg, #729cf9, #5945db);
  background: linear-gradient(90deg, $primary, $secondary);
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  // color: #2d3766;
  color: #4d5786;
  // background-color: #e1e4f2;
  // background-color: #eff3f8;
  font-family: "Eina", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  // font-size: 0.875rem;
}

html,
body,
#sapp__view {
  // background-color: #f7f6fb;
  background-color: #f6f7fc;
}

html,
body,
#sapp,
.layout-guest,
.layout-dashboard {
  position: relative;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}

/* SAPP FONT */
.sappfont,
.sappfont:before {
  display: inline-block;
}
.sappfont {
  vertical-align: top;
}
.sappfont.sappfont-fw {
  width: 1em;
  text-align: center;
}

.grad-purple-to-violet {
  background: linear-gradient(90deg, #651589, #3c1f98) !important;
}

.gradient-primary {
  background-color: #5d0dc8;
  // background: linear-gradient(180deg, #4438df, #48bdfc);
  background: linear-gradient(180deg, $primary, #48bdfc);
  background: linear-gradient(180deg, #4705b1, #4438df);
  background: $gradient-primary;
  // background: linear-gradient(180deg, #4438df, #5d0dc8);
  // color: #fff;
  // a,
  // .title,
  // .subtitle {
  //   color: #fff;
  // }
}

input.input-is-fat {
  padding: 1.5rem 1rem;
}
input.input-is-dark {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
input.input-is-dark::placeholder {
  color: #fff;
  opacity: 0.75;
}

.viewport-size {
  min-width: 100vw;
  min-height: 100vh;
}
.viewport-width {
  min-width: 100vh;
}
.viewport-height {
  min-height: 100vh;
}
.layout-dashboard .viewport-height {
  min-height: calc(100vh - 4rem);
}

/* VIEW */
@media only screen {
  #sapp__view {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    // top: 3.125rem;
    // height: 100vh;
    // min-height: calc(100vh - 4rem);
    overflow-y: auto;
    scroll-behavior: smooth;
    will-change: scroll;
    -webkit-overflow-scrolling: touch;
    display: flex;
    align-items: center;
    justify-content: center;
    .view {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .view__bar,
    .view__content {
      // padding: 0 $column-gap;
      padding: 1rem;
      width: 100%;
    }
    .view__bar {
      position: relative;
      z-index: 2;
      border-bottom: 1px solid #eee;
      background-color: #fff;
      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:not(:last-child) {
          margin-bottom: $column-gap;
        }
        .rowColumn {
          display: flex;
          align-items: center;
          &.grow {
            flex: 1 0 0;
          }
        }
      }
      .container {
        .columns {
          justify-content: space-between;
        }
        .column {
          display: flex;
          align-items: center;
        }
      }
      .app-back {
        display: inline-block;
        margin-right: 2rem;
      }
      .bar__title,
      .title {
        color: #474c63;
        font-weight: bold;
        font-size: 1.125rem;
        margin-bottom: 0;
      }
    }
    .view__content {
      flex: 1 1 auto;
      overflow: auto;
      scroll-behavior: smooth;
      will-change: scroll;
      -webkit-overflow-scrolling: touch;
      // padding: $column-gap * 2;
    }
  }
  .layout-dashboard {
    #sapp__view {
      .view__bar {
        box-shadow: 0 1px 8px 0 rgba(117, 117, 117, 0.3);
      }
    }
  }
  .layout-guest {
    background: $gradient-primary;
  }
  @media (max-width: 39.9375em) {
    .layout-dashboard {
      #sapp__view {
        bottom: 4rem;
      }
    }
  }
  @media (min-width: 40em) {
    .layout-dashboard {
      #sapp__view {
        top: 4rem;
      }
    }
  }
}

/* BOX */
@media only screen {
  .sbox {
    position: relative;
    margin-bottom: 0.5rem;
  }
  .sbox,
  .sbox-lvl-1 {
    border-radius: 0.25rem;
    border-radius: 0.375rem;
    // border-radius: 0.5rem;
  }

  .sbox-lvl-1 {
    background-color: #fff;
    box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
    /*box-shadow: 0 2px 5px 0 rgba(45,62,80,.12);*/
    /*box-shadow: 0 3px 6px 0 rgba(45,62,80,.16);*/
  }
  .sbox-heading,
  .sbox-button {
    transition: all 0.1s linear;
  }
  .sbox-pad {
    padding: 1rem;
  }
  .sbox-title {
    color: #33475b;
    margin-bottom: 0.75em;
    font-weight: 600;
    /* color: #150233; */
    /* color: #8da5c7; */
    /* color: #32067c; */
  }
  .sbox-header {
    border-bottom: 1px solid #f6f9fb;
  }
  .sbox-header .sbox-title {
    margin: 0;
  }
  .sbox-button {
    cursor: pointer;
    border: 1px solid #dedede;
    text-align: center;
    background: transparent;
    text-decoration: none;
    padding: 1rem;
    color: #5616ed;
    font-size: 1.125em;
    min-width: 14.375rem;
  }
  .sbox-button:hover {
    color: #fff;
    background-color: #5616ed;
  }
  .sbox-heading {
    color: #5616ed;
    font-size: 1.75em;
    font-weight: 300;
    line-height: 1.2;
  }
  .call-to-action .action .sbox-button {
    width: 100%;
    max-width: 20rem;
  }
  .sbox-purple {
    background-color: #5616ed;
  }
  .sbox-purple .sbox-heading {
    color: #fff;
  }
  .sbox-purple .sbox-button {
    color: #fff;
  }
  .sbox-purple .sbox-button:hover {
    background-color: #fff;
    color: #5616ed;
  }
  @media (max-width: 39.9375em) {
    .sbox,
    .sbox.sbox-lvl-1 {
      border-radius: 0;
    }
  }
  @media (min-width: 40em) {
    .sbox {
      margin-bottom: 1rem;
    }
    .sbox.sbox-pad {
      padding: 0;
    }
    .sbox .sbox-title {
      font-size: 1rem;
    }
  }
  @media (min-width: 64em) {
    .sbox {
      margin-bottom: 2rem;
    }
    .sbox-pad {
      padding: 1rem 1.5rem;
    }
    .content_area:not(.side) .call-to-action {
      display: flex;
      align-items: center;
    }
  }
}
</style>
